import { createContext, useState, } from 'react';
import { useAccount, useBalance } from 'wagmi';

export const connectionContext = createContext({
    isConnected: false,
    address: '',
    isDisconnected: true,
    isConnecting: false,
    isReconnecting: false,
    isApiPending: false,
    setIsApiPending: () => {},
    balance: '0.00',
    isFetchingBalance: false,
    refetchBalance: () => {},
});

const ConnectionStatus = ({ children }) => {
    const {
        address,
        isConnected,
        connector,
        isDisconnected,
        isConnecting,
        isReconnecting,
    } = useAccount();
    const {
        data: balance,
        refetch: refetchBalance,
        isLoading: isFetchingBalance,
    } = useBalance({
        address: address,
    });

    const [isApiPending, setIsApiPending] = useState(false);

    return (
        <connectionContext.Provider
            value={{
                isConnected,
                address: address,
                isDisconnected,
                isConnecting,
                isReconnecting,
                isFetchingBalance,
                isApiPending,
                setIsApiPending,
                balance: balance?.formatted,
                refetchBalance,
                connector,
            }}
        >
            {children}
        </connectionContext.Provider>
    );
};

export default ConnectionStatus;
